import mitt from 'mitt'
import { createBrowserHistory, type History } from 'history'
import { KAMBI_ROOT_ROUTE } from '@core/Areas/KambiClient/constants'

export const appHistory = createBrowserHistory() as History

// Used to listen for Kambi internal route changes
export const browserHistoryEmitter = mitt<{ pushState: string }>()

const pushState = (url: string) => browserHistoryEmitter.emit('pushState', url)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type PushStateArgs = [data: any, unused: string, url?: string | URL | null]

if (window.history) {
  // Only necessary while Kambi's internal router replaces mobi home URL with kambi home URL
  window.history.replaceState = new Proxy(window.history.replaceState, {
    apply: (target, thisArg, argArray: PushStateArgs) => {
      const [data, , url] = argArray

      const shouldForce = data?.usr?.force ?? false
      const destination = url?.toString() || location.pathname

      if (!shouldForce && destination.includes(KAMBI_ROOT_ROUTE) && location.pathname === '/') {
        // eslint-disable-next-line no-console
        console.warn(`Ignored replaceState for ${destination}. We are not inside kambi`)
        return
      }
      return target.apply(thisArg, argArray)
    },
  })

  // Only necessary while Kambi's internal router replaces current with the same
  // (doubles stack history, breaking expected native back)
  window.history.pushState = new Proxy(window.history.pushState, {
    apply: (target, thisArg, argArray: PushStateArgs) => {
      const [, , url] = argArray

      const destination = url?.toString() || location.pathname

      if (destination.includes(KAMBI_ROOT_ROUTE) && location.pathname === destination) {
        // eslint-disable-next-line no-console
        console.warn(`Ignored pushState for ${destination}. We are not inside kambi`)
        return
      }

      pushState(destination)
      return target.apply(thisArg, argArray)
    },
  })
}
